import { HttpParams } from '@angular/common/http';
import { Params } from '@angular/router';
import { CardPage } from '../../card/model/card-page';
import { SortBy } from '../enums/sortby.enum';

export class Pageable {
    page: number;
    pageSize: number;
    sortBy: SortBy;
    asc: boolean;
    searchText: string;
    types: string;
}

export function createPageableByRouterParameters(
    pageable: Pageable,
    params: Params
): Pageable {
    pageable.page = params.page;
    if (!pageable.page) {
        pageable.page = 1;
    }
    pageable.pageSize = params.pageSize;
    pageable.sortBy = params.sortBy;
    pageable.asc = params.asc;
    pageable.searchText = params.searchText;
    if (params.types) {
        pageable.types = params.types;
    }
    return pageable;
}

export function setDefaultWorkspaceSortingParameters(cardPage: CardPage) {
    cardPage.pageable.pageSize = 6;
}

export function httpByPageable(
    httpParams: HttpParams,
    pageable: Pageable
): HttpParams {
    return httpByPageableInfo(
        httpParams,
        pageable.page,
        pageable.pageSize,
        pageable.sortBy,
        pageable.asc,
        pageable.searchText,
        pageable.types
    );
}

function httpByPageableInfo(
    httpParams: HttpParams,
    page: number,
    pageSize: number,
    sortedBy: string,
    asc: boolean,
    searchText: string,
    types?: string
): HttpParams {
    if (searchText) {
        httpParams = httpParams.set('searchText', searchText.toString());
    }
    if (page) {
        httpParams = httpParams.set('page', page + '');
    }
    if (pageSize) {
        httpParams = httpParams.set('pageSize', pageSize + '');
    }
    if (sortedBy !== undefined) {
        httpParams = httpParams.set('sortBy', sortedBy);
    }
    if (asc !== undefined) {
        httpParams = httpParams.set('asc', asc);
    }
    if (types !== undefined) {
        httpParams = httpParams.set('types', types);
    }
    return httpParams;
}

/**
 * Generic Paging Result.
 */
export class PagingResult<V> {
    values: V[];
    count: number;
    totalElements: number;
    totalPages: number;
}
